import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { NewquanlytonkhoAction } from 'src/actions/newquanlytonkho.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    MenuItem,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
} from '@material-ui/core';

import Select from 'react-select';

import { Search as SearchIcon } from 'react-feather';

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
    SIM_TYPE_LIST_OBJ_WITHOUT_OPERATOR,
} from 'src/utils/constants';

import { isGrantPermission } from 'src/utils/utils';
import { NewdanhmucnhacungcapAction } from 'src/actions/newdanhmucnhacungcap.action';

import CreateEditDialogNewdanhmucnhacungcap from '../newdanhmucnhacungcap-detail/CreateEditDialog';
import CreateEditDialogNewdanhmucphieunhap from '../newdanhmucphieunhap-detail/CreateEditDialog';
import CreateEditDialogNewdanhmucphieuxuat from '../newdanhmucphieuxuat-detail/CreateEditDialog';
import { NewdanhmucphieunhapAction } from 'src/actions/newdanhmucphieunhap.action';
import { NewdanhmucphieuxuatAction } from 'src/actions/newdanhmucphieuxuat.action';

const ViewDetailDialog = (props) => {
    const dispatch = useDispatch()
    const { items } = useSelector(state => state.permission)
    const { selected } = useSelector(state => state.newquanlytonkho)
    const { info, permissions, role } = useSelector(state => state.profile)
    const [ma, setMa] = useState("")
    const [ten, setTen] = useState("")
    const [gia_nhap, setGiaNhap] = useState("0")
    const [gia_thuc_nhap_si_1, setGiaThucNhapSi1] = useState("0")
    const [gia_thuc_nhap_si_2, setGiaThucNhapSi2] = useState("0")
    const [gia_thuc_nhap_si_3, setGiaThucNhapSi3] = useState("0")
    const [giaxuat1, setGiaXuat1] = useState("0")
    const [giaxuat2, setGiaXuat2] = useState("0")
    const [giaxuat3, setGiaXuat3] = useState("0")
    const [chiet_khau_1, setChietKhau1] = useState("0")
    const [chiet_khau_2, setChietKhau2] = useState("0")
    const [chiet_khau_3, setChietKhau3] = useState("0")

    const [nhacungcap_id, setNhacungcapId] = useState("-99");
    const [nhacungcap_name, setNhacungcapName] = useState("");
    const [nhacungcap_select, setNhacungcapSelect] = useState(undefined);
    const [nhacungcapList, setNhacungcapList] = useState([]);

    const additionalOptionNhacungcap = { 'id': '-99', 'ma': 'Nhà cung cấp...', 'ten': '' };

    const [openNewdanhmucnhacungcap, setOpenNewdanhmucnhacungcap] = useState(false);
    const [openNewdanhmucphieunhap, setOpenNewdanhmucphieunhap] = useState(false);
    const [openNewdanhmucphieuxuat, setOpenNewdanhmucphieuxuat] = useState(false);

    //==========

    const handleClickOpenNewdanhmucnhacungcap = () => {
        setOpenNewdanhmucnhacungcap(true);
    };

    const handleCloseNewdanhmucnhacungcap = () => {
        setOpenNewdanhmucnhacungcap(false);
        fetchData();
    };

    //==========

    const onSelectedNewdanhmucphieunhap = (id) => {
        dispatch(NewdanhmucphieunhapAction.findOne(id));
        setOpenNewdanhmucphieunhap(true);
    };

    const handleClickOpenNewdanhmucphieunhap = () => {
        setOpenNewdanhmucphieunhap(true);
    };

    const handleCloseNewdanhmucphieunhap = () => {
        setOpenNewdanhmucphieunhap(false);
    };

    //==========

    const onSelectedNewdanhmucphieuxuat = (id) => {
        dispatch(NewdanhmucphieuxuatAction.findOne(id));
        setOpenNewdanhmucphieuxuat(true);
    };

    const handleClickOpenNewdanhmucphieuxuat = () => {
        setOpenNewdanhmucphieuxuat(true);
    };

    const handleCloseNewdanhmucphieuxuat = () => {
        setOpenNewdanhmucphieuxuat(false);
    };

    //==========

    const fetchData = async() => {
        // const _nhacungcapList = await dispatch(NewdanhmucnhacungcapAction.nhacungcapList());
        // if (_nhacungcapList && typeof _nhacungcapList.data !== 'undefined' && typeof _nhacungcapList.data.values !== 'undefined') setNhacungcapList(_nhacungcapList.data.values);
    }

    useEffect(() => {
        console.log(selected);
    }, [props])

    return (<>
        {selected?.data && <Dialog className='khophieu-view' open={props.open} onClose={props.handleClose}>
            <DialogTitle>Chi tiết nhập/xuất của sản phẩm [<span style={{color: 'red', fontWeight: 'bold'}}>{selected.data.sanpham_ma}</span> (<span style={{color: 'red', fontWeight: 'bold'}}>{selected.data.sanpham_ten}</span>)] từ ngày <span style={{color: 'red', fontWeight: 'bold'}}>{selected.data.startDate}</span> đến ngày <span style={{color: 'red', fontWeight: 'bold'}}>{selected.data.endDate}</span></DialogTitle>
            <DialogContent style={{ width: '100%', paddingTop: 20 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Số khung / Số máy</TableCell>
                            <TableCell>Kho</TableCell>
                            <TableCell>Phiếu nhập</TableCell>
                            <TableCell>Ngày nhập</TableCell>
                            <TableCell>Phiếu xuất</TableCell>
                            <TableCell>Ngày xuất</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {selected?.data?.values &&
                            selected.data.values
                                .filter(item => item.type === 'nhap')
                                .map((item, index) => {
                                    // Tìm phiếu xuất tương ứng (nếu có)
                                    const matchedXuat = selected.data.values.find(
                                        x =>
                                            x.type === 'xuat' &&
                                            x.so_khung === item.so_khung &&
                                            x.so_may === item.so_may
                                    );

                                    // Định dạng ngày nhập và xuất
                                    const ngayNhap = `${item.phieu_ngay}/${item.phieu_thang}/${item.phieu_nam}`;
                                    const ngayXuat = matchedXuat
                                        ? `${matchedXuat.phieu_ngay}/${matchedXuat.phieu_thang}/${matchedXuat.phieu_nam}`
                                        : '';

                                    return (
                                        <TableRow
                                            hover
                                            key={item.so_khung + '_' + index}
                                        >
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>{item.so_khung}<br></br>{item.so_may}</TableCell>
                                            <TableCell>{item.khohang_ma} - {item.khohang_ten}</TableCell>
                                            <TableCell style={{color: 'green'}}>
                                                {(role.priority < 4) && <Button onClick={() => onSelectedNewdanhmucphieunhap(item.phieu_id)} className="btn-go-to-phieu-nhap">
                                                    {item.phieu_ma}
                                                </Button>}
                                                {(role.priority >= 4) && item.phieu_ma}
                                            </TableCell>
                                            <TableCell>{ngayNhap}</TableCell>
                                            <TableCell style={{color: 'red'}}>
                                                {(role.priority < 4) && <Button onClick={() => onSelectedNewdanhmucphieuxuat(matchedXuat?.phieu_id || '')} className="btn-go-to-phieu-xuat">
                                                    {matchedXuat?.phieu_ma || ''}
                                                </Button>}
                                                {(role.priority >= 4) && (matchedXuat?.phieu_ma || '')}
                                            </TableCell>
                                            <TableCell>{ngayXuat}</TableCell>
                                        </TableRow>
                                    );
                                })}
                    </TableBody>
                </Table>

                <h3 style={{ marginTop: 32 }}>
                    Dưới đây là danh sách các bộ số khung - số máy <span style={{color: 'red', fontWeight: 'bold'}}>ĐÃ GHI NHẬN XUẤT KHO</span> nhưng <span style={{color: 'red', fontWeight: 'bold'}}>CHƯA GHI NHẬN NHẬP KHO</span> từ ngày <span style={{color: 'red', fontWeight: 'bold'}}>{selected.data.startDate}</span> đến ngày <span style={{color: 'red', fontWeight: 'bold'}}>{selected.data.endDate}</span>
                </h3>
                <Table style={{ marginTop: 32 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Số khung / Số máy</TableCell>
                            <TableCell>Kho</TableCell>
                            <TableCell>Phiếu xuất</TableCell>
                            <TableCell>Ngày xuất</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {selected?.data?.values &&
                            selected.data.values
                                .filter(item => item.type === 'xuat')
                                .filter(
                                    item =>
                                        !selected.data.values.some(
                                            nhap =>
                                                nhap.type === 'nhap' &&
                                                nhap.so_khung === item.so_khung &&
                                                nhap.so_may === item.so_may
                                        )
                                )
                                .map((item, index) => {
                                    const ngayXuat = `${item.phieu_ngay}/${item.phieu_thang}/${item.phieu_nam}`;

                                    return (
                                        <TableRow
                                            hover
                                            key={item.so_khung + '_xuat_' + index}
                                        >
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>{item.so_khung}<br></br>{item.so_may}</TableCell>
                                            <TableCell>{item.khohang_ma} - {item.khohang_ten}</TableCell>
                                            <TableCell style={{color: 'red'}}>
                                                {(role.priority < 4) && <Button onClick={() => onSelectedNewdanhmucphieuxuat(item.phieu_id)} className="btn-go-to-phieu-xuat">
                                                    {item.phieu_ma}
                                                </Button>}
                                                {(role.priority >= 4) && (item.phieu_ma)}
                                            </TableCell>
                                            <TableCell>{ngayXuat}</TableCell>
                                        </TableRow>
                                    );
                                })}
                    </TableBody>
                </Table>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose}>Đóng</Button>
            </DialogActions>
            <CreateEditDialogNewdanhmucnhacungcap open={openNewdanhmucnhacungcap} handleClose={handleCloseNewdanhmucnhacungcap} type={"CREATE"} creatingFromAway={true} />
            <CreateEditDialogNewdanhmucphieunhap open={openNewdanhmucphieunhap} handleClose={handleCloseNewdanhmucphieunhap} type={"EDIT"} creatingFromAway={true} />
            <CreateEditDialogNewdanhmucphieuxuat open={openNewdanhmucphieuxuat} handleClose={handleCloseNewdanhmucphieuxuat} type={"EDIT"} creatingFromAway={true} />
        </Dialog >}
    </>);
}

export default ViewDetailDialog;